import { get, post } from "services/services.methods";
import { PurchasePaths } from 'services/services.paths';
import { PurchaseR } from '../../../interfaces/PurchasingRegistration/index';

export const createPurchasingRegistration = async (Purchase: PurchaseR) => {
  const response = await post<any>(PurchasePaths.post, Purchase);

  return response;
};


